import * as React from 'react';
import { useAppDispatch } from '../../hooks';
import { updateTableFact } from '../../redux/AfrSlice';
import { AccountEditorGridNoSubAccountBulk, IAccountEditorGridNoSubaccountsOptions } from '../core/AccountEditorGridNoSubAccountBulk';


const RevenuesCoreDetail = (props: {
    doneFlag: string,
    noFlag: string,
    setHasData: (hasData: boolean) => void
    fundGroup: string | null
}) => {
    const dispatch = useAppDispatch();

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "uas_020_revenue",
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));
         
    }

    const editorOptions: IAccountEditorGridNoSubaccountsOptions = {
        gridname: "revenues",
        cellEditHandler: handleCellEdited,
        doneFlag: props.doneFlag,
        noFlag: props.noFlag,
        fixedRows: false,
        firstFieldId: "FG_001_GeneralFundMember",
        allowedCombinations: null,
        dimensionColumn: null,
        accountRangeFilter: null,
        accountGroups: null,
        columnFilter: props.fundGroup
    };

    return (
        <React.Fragment>
            <div>
                <AccountEditorGridNoSubAccountBulk
                    tableName="uas_020_revenue"
                    gridData={[]}
                    gridColumns={[]}
                    gridOptions={{}}
                    options={editorOptions}
                    setHasData={props.setHasData}
                />
            </div>
        </React.Fragment>
    );
}

export default RevenuesCoreDetail;